export enum States {
  Unset = 'UNSET',
  New = 'NEW',
  Confirmed = 'CONFIRMED',
}

export enum Directions {
  Ingress = 'INGRESS',
  Egress = 'EGRESS',
}

export enum Types {
  IP = 'IP',
  URL = 'URL',
}

export enum ValidationStates {
  Valid = 'VALID',
  Invalid = 'INVALID',
}
